import { useQuery } from '@tanstack/react-query'

import { getVcnManagementCarriers } from '../../../api/vcn-management-api-client'

export function useVcnManagementCarriers() {
  return useQuery({
    queryKey: ['vcn-management-carriers'],
    queryFn: getVcnManagementCarriers,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  })
}
